import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  RedirectCommand,
} from '@angular/router';
import { AppConfigService } from '../services/app-config.service';
import { AuthService } from '../services/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private configService: AppConfigService,
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree | RedirectCommand> {
    await this.configService.loadAppConfig();
    const authService = this.injector.get(AuthService);
    
    if(isPlatformBrowser(this.platformId)) {
      await authService.awaitStartupAuth();
    }

    if (authService.isAuthenticated()) {
      if (route.data['roles']) {
        const roles = authService.roles;
        if (roles.includes('Admin')) {
          return true;
        }

        var found = false;
        roles.forEach((r) => {
          if (route.data['roles'].includes(r)) {
            found = true;
          }
        });
        if (!found) {
          this.router.navigate(['/access-denied']);
        }
      }
      return true;
    }

    if(isPlatformBrowser(this.platformId))
    {
      localStorage.setItem('redirect', state.url);
      await authService.login();
    }
    return false;
  }
}
